import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, Row, Col, Button, Icon, Tooltip } from 'antd';
import { GreenRoundCheck, RoundedMinusIcon } from '../../../../components/common/CustomIcon';
import { getGCSUrl } from '../../../../../services/Common';

const JobSkillList = (props) => {
  const [page, setPage] = useState(1);
  const [pageSize] = useState(3);
  const [pageCount, setPageCount] = useState(0);
  const [skillArray, setSkillArray] = useState([]);

  const initialize = () => {
    if (props.skills && Array.isArray(props.skills) && props.skills.length > 3) {
      const noOfPages = Math.ceil(props.skills.length / pageSize);
      setPageCount(noOfPages);
      const newArray = props.skills.slice(0, pageSize);
      setSkillArray(newArray);
      if (page < 1) setPage(1);
      else if (page > noOfPages) setPage(noOfPages);
    } else {
      setSkillArray(props.skills);
    }
  };

  const onClickNext = () => {
    const newPage = page + 1;
    const startFrom = page * pageSize;
    const limit = startFrom + pageSize;
    const newArray = props.skills.slice(startFrom, limit);
    setSkillArray(newArray);
    setPage(newPage);
  };

  const onClickPrev = () => {
    const newPage = page - 1;
    const limit = newPage * pageSize;
    const startFrom = limit - pageSize;
    const newArray = props.skills.slice(startFrom, limit);
    setSkillArray(newArray);
    setPage(newPage);
  };

  useEffect(() => {
    initialize();
  }, []);

  return (
    <div className="job-card-skill">
      <Row style={{ marginBottom: props.forJobCardV2 ? 0 : '20px' }} type="flex" justify="space-between">
        { props.forJobCardV2 ? null : <div><Typography.Text className="job-skill-title">Required skills</Typography.Text></div> }
        <div>
          {props.skills && Array.isArray(props.skills) && props.skills.filter(skill => skill.linked_mcq_id).length > 3
            ? (
              <div>
                {page > 1 ? <Icon type="left" onClick={onClickPrev} /> : null}
                {page < pageCount ? <Icon type="right" onClick={onClickNext} /> : null}
              </div>
            )
            : null }
        </div>
      </Row>
      {
        skillArray && skillArray.length > 0
          ? (
            skillArray.filter(skill => skill.linked_mcq_id).map((skill, index) => (
              <Row type="flex" align="middle" style={{ marginBottom: '2px' }} key={`${skill.skill_id}_${(new Date()).getTime()}_${index}`}>
                <Col span={2} style={{ marginLeft: '-5px' }}>
                  { skill.skill_icon_url
                    ? <img src={`${getGCSUrl()}/icon/${skill.skill_icon_url}`} className="job-skill-icon" />
                    : <div className="gray-round-icon" />
                  }
                </Col>
                <Col span={12} style={{ marginLeft: '12px' }}><Typography.Text className="job-skill-name">{skill.skill_name}</Typography.Text></Col>
                <Col span={9} style={{ textAlign: 'right' }}>
                  {
                    skill.status && skill.status.toLowerCase() === 'passed' ? <GreenRoundCheck /> : null
                  }
                  {
                    skill.status && skill.status.toLowerCase() === 'failed' ? <Tooltip title='You did not pass this skill. Please try again in 3 months'><RoundedMinusIcon /></Tooltip> : null
                  }
                  { skill.status && skill.status.toLowerCase() === 'inprogress' &&
                    (
                      <Button style={{ float: 'right' }} onClick={() => props.onStartTest(skill.skill_name, skill.linked_mcq_id, skill.acc_challenge)} type="link" className="job-mcq-start">Continue Quiz</Button>
                    )
                  }
                  { skill.status && skill.status.toLowerCase() === 'not_taken' && skill.linked_mcq_id && skill.linked_mcq_id !== '' &&
                    (
                      <Button style={{ float: 'right' }} onClick={() => props.onStartTest(skill.skill_name, skill.linked_mcq_id, skill.acc_challenge)} type="link" className="job-mcq-start">Start Quiz</Button>
                    )
                  }
                  { skill.status && skill.status.toLowerCase() === 'not_taken' && (!skill.linked_mcq_id || skill.linked_mcq_id === '') &&
                    (
                      <small className='no-test-available'>No test available</small>
                    )
                  }
                </Col>
              </Row>
            ))
          )
          : null
      }
    </div>
  );
};

JobSkillList.propTypes = {
  skills: PropTypes.array,
  forJobCardV2: PropTypes.bool,
  onStartTest: PropTypes.func
};

export default React.memo(JobSkillList);
